import Vue from 'vue';
import ls from './tools/ls';

export default {
  namespaced: true,
  state: {
    token: null,
    loaded: false,
    settings: {},
    products: {},
    menus: {},
    sections: [],
    tags: {},
    order: ls.init('order', Object, {}),
    address: ls.init('address', Object, {}),
    point: ls.init('point', Number, null),
    area: ls.init('area', String, null),
    points: [],
    mode: ls.init('mode', String, 'delivery'),
  },
  mutations: {
    token(state, token) {
      state.token = token;
    },
    field(state, { field, value }) {
      state[field] = Object.freeze(value);
    },
    sections(state, sections) {
      state.sections = Object.freeze(sections);
    },
    address(state, address) {
      state.address = {};
      Vue.set(state, 'address', address);
      ls.set('address', state.address);
    },
    point(state, point) {
      if (point === 'null') {
        state.point = null;
      } else {
        state.point = point;
      }
      ls.set('point', point);
    },
    area(state, area) {
      state.area = area;
      ls.set('area', area);
    },
    mode(state, mode) {
      state.mode = mode;
      ls.set('mode', state.mode);
    },
    order(state, { field, value }) {
      state.order[field] = value;
      Vue.set(state, 'order', state.order);
      ls.set('order', state.order);
    },
  },
};
